import { Directive, HostListener, Input } from '@angular/core';
import { AuditModalComponent } from '@components/audit-modal/audit-modal.component';
import { IAuditData } from '@interfaces/common.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[auditModal]',
})
export class AuditModalDirective {
  @Input('auditModal') auditData: Record<string, any> & IAuditData;

  constructor(private readonly modalService: NgbModal) {}

  @HostListener('click', ['$event'])
  openAuditModal(event: Event): void {
    event.stopPropagation();
    const modal = this.modalService.open(AuditModalComponent);
    (modal.componentInstance as AuditModalComponent).recordData = this.auditData;
  }
}
